<div class="pts-wrapper" *ngIf="loaded">

  <!-- Fila 1: Input de búsqueda -->
  <div class="pts-search-row">
    <span class="pts-search-icon">
      <i class="pi pi-search"></i>
      <span class="pts-badge" *ngIf="searchTerms.length > 0">{{ searchTerms.length }}</span>
    </span>
    <input
      pInputText
      type="text"
      name="search_filter"
      id="search_filter"
      autocapitalize="none"
      spellcheck="false"
      #searchFilter
      autocomplete="off"
      [(ngModel)]="inputValue"
      (input)="onInputChange($any($event.target).value)"
      (keyup.enter)="addFilter(searchFilter)"
      class="pts-input"
      [placeholder]="'PRODUCT.SEARCH_TEXT' | translate"
    />
    <!-- Toggle AND/OR: HTML nativo, control total del tamaño -->
    <div class="pts-type-toggle">
      <button
        type="button"
        class="pts-type-btn"
        [class.pts-type-btn--active]="searchType === 'AND'"
        (click)="changeSearchType('AND')"
      >AND</button>
      <button
        type="button"
        class="pts-type-btn"
        [class.pts-type-btn--active]="searchType === 'OR'"
        (click)="changeSearchType('OR')"
      >OR</button>
    </div>
  </div>

  <!-- Fila 2: Chips activos (solo cuando hay) -->
  <div class="pts-chips-row" *ngIf="searchTerms.length > 0">
    <p-chip
      *ngFor="let item of searchTerms"
      [label]="item"
      [removable]="true"
      styleClass="pts-chip"
      (onRemove)="removeSearchItem(item)"
    />
    <button type="button" class="pts-clear-btn" (click)="clearAllFilters()" title="Limpiar filtros">
      <i class="pi pi-times"></i>
    </button>
  </div>

  <!-- Fila 3: Info compacta + hamburger -->
  <div class="pts-info-row">
    <app-product-toolbar-search-info
      [(showInsertedProducts)]="showInsertedProducts"
      [filteredProducts]="viewedProducts"
      [allProducts]="allProducts"
      [viewType]="viewType"
      [filterOptions]="filterOptions"
      [productOrder]="productOrder"
      (viewTypeChange)="changeViewType($event)"
      (orderChange)="changeOrder($event)"
      [loading]="loading"
    />
    <button
      type="button"
      class="pts-options-btn"
      (click)="showHistory.emit()"
      [pTooltip]="'FASCICLE.HISTORY' | translate"
      tooltipPosition="left"
    >
      <i class="pi pi-history"></i>
    </button>
    <button
      type="button"
      class="pts-options-btn"
      (click)="optionsPanel.toggle($event)"
      [class.pts-options-btn--active]="showInsertedProducts || showProductDetailsTooltip"
      title="Opciones"
    >
      <i class="pi pi-sliders-h"></i>
      <span class="pts-options-dot" *ngIf="showInsertedProducts || showProductDetailsTooltip"></span>
    </button>
  </div>

  <!-- Panel de opciones -->
  <p-overlayPanel #optionsPanel styleClass="pts-options-panel" [dismissable]="true" appendTo="body">
    <div class="pts-panel-content">
      <!-- Selector de campo de ordenación -->
      <div class="pts-panel-section">
        <span class="pts-panel-section-label">{{ 'PRODUCT.SORT.SORT_BY' | translate }}</span>

        <div class="pts-sort-field-list" *ngIf="sortableFields.length > 0">
          <div class="pts-sort-group-label">{{ 'PRODUCT.SORT.FIELDS' | translate }}</div>
          <ng-container *ngFor="let field of sortableFields; let i = index">
            <!-- Separador antes del primer campo extra -->
            <div
              class="pts-sort-group-label"
              *ngIf="field.group === 'extra' && (i === 0 || sortableFields[i - 1].group === 'standard')"
            >Extra</div>
            <div
              class="pts-sort-field-item"
              [class.pts-sort-field-item--active]="sortField === field.value"
              [class.pts-sort-field-item--extra]="field.group === 'extra'"
              (click)="changeSortField(field.value)"
            >
              <i class="pts-sort-field-icon" [ngClass]="field.group === 'extra' ? 'pi pi-sliders-v' : 'pi pi-tag'"></i>
              <span class="pts-sort-field-label">{{ field.label }}</span>
              <i class="pi pi-check pts-sort-field-check" *ngIf="sortField === field.value"></i>
            </div>
          </ng-container>
        </div>

        <div class="pts-sort-empty" *ngIf="sortableFields.length === 0">
          <span>—</span>
        </div>
      </div>
      <!-- Dirección de ordenación -->
      <div class="pts-direction-toggle">
        <button
          type="button"
          class="pts-direction-btn"
          [class.pts-direction-btn--active]="productOrder === 'asc'"
          (click)="changeOrder('asc')"
        ><i class="pi pi-arrow-up"></i> A→Z</button>
        <button
          type="button"
          class="pts-direction-btn"
          [class.pts-direction-btn--active]="productOrder === 'desc'"
          (click)="changeOrder('desc')"
        ><i class="pi pi-arrow-down"></i> Z→A</button>
      </div>

      <div class="pts-panel-divider"></div>
      <label class="pts-option-label">
        <p-checkbox
          [(ngModel)]="showInsertedProducts"
          [binary]="true"
          (onChange)="toggleShowInsertedProducts()"
          styleClass="pts-checkbox"
        />
        <span>{{ 'PRODUCT.SHOW_INSERTED_PRODUCTS' | translate }}</span>
      </label>
      <label class="pts-option-label">
        <p-checkbox
          [(ngModel)]="showProductDetailsTooltip"
          [binary]="true"
          (onChange)="toogleShowProductDetails()"
          styleClass="pts-checkbox"
        />
        <span>{{ 'PRODUCT.SHOW_TOOLTIP' | translate }}</span>
      </label>
    </div>
  </p-overlayPanel>

</div>
